/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function DownArrow(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 18 10" fill="none" height={size} width={size} {...other}>
      <path
        d="M0.857147 1.09999L8.17681 8.41965C8.23024 8.47658 8.29477 8.52195 8.36641 8.55297C8.43806 8.58399 8.51531 8.59999 8.59338 8.59999C8.67145 8.59999 8.74869 8.58399 8.82034 8.55297C8.89199 8.52195 8.95652 8.47658 9.00994 8.41965L16.3296 1.09999"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

DownArrow.defaultProps = {
  color: "currentColor",
  size: 24,
};

DownArrow.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
